import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { TaktIdProvider, createStormTaktId, Flex, HelpTip } from '@amzn/storm-ui';
import { D as DisabledLink, S as StyledLink } from './LinkAttribute.styles-9sb-WS-1.js';

const LinkAttribute = ({
  id,
  children,
  href,
  external = false,
  disabled = false,
  helptipText,
  helptipTextPosition = 'right',
  taktId,
  taktValue,
  ...rest
}) => /*#__PURE__*/React__default.createElement(TaktIdProvider, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('page-header-link-attribute')
}, /*#__PURE__*/React__default.createElement(Flex, {
  alignItems: "center",
  id: id
}, disabled ? /*#__PURE__*/React__default.createElement(DisabledLink, null, children) : /*#__PURE__*/React__default.createElement(StyledLink, _extends({}, rest, {
  href: href,
  external: external,
  target: external ? '_blank' : undefined
}), children), !!helptipText && /*#__PURE__*/React__default.createElement(HelpTip, {
  position: helptipTextPosition
}, helptipText)));

export { LinkAttribute as L };
//# sourceMappingURL=LinkAttribute-EdMkvGgD.js.map
